function matchChannel(channelsToMatch: string | string[], channelId: string) {
  const channelsToMatchType = typeof channelsToMatch;

  return channelsToMatchType === 'string' ? channelId === channelsToMatch : channelsToMatch.includes(channelId);
}

export default matchChannel;
